import { z } from "zod";

export const ProductCategorySchema = z.enum([
	"MEDICAL_CANNABIS",
	"ACCESSORIES",
	"EQUIPMENT",
	"SUPPLEMENTS",
	"OTHER",
]);

export const ProductStatusSchema = z.enum([
	"active",
	"inactive",
	"out_of_stock",
	"discontinued",
	"removed",
]);

export const ProductSchema = z.object({
	id: z.string().min(1),
	sku: z.string().min(1, "מזהה מוצר הוא שדה חובה"),
	name: z.string().min(1, "שם המוצר הוא שדה חובה"),
	description: z.string().min(10, "תיאור המוצר חייב להכיל לפחות 10 תווים").optional(),
	shortDescription: z.string().max(100, "תיאור קצר לא יכול לעלות על 100 תווים").optional(),
	price: z.number().min(0, "מחיר לא יכול להיות שלילי"),
	stock: z.number().int().min(0, "מלאי לא יכול להיות שלילי").optional(),
	status: ProductStatusSchema.default("active"),
	createdAt: z.number(),
	updatedAt: z.number(),
});

export const PharmacyProductSchema = ProductSchema.extend({
	discountPrice: z.number().int().min(1, "כמות בחבילה חייבת להיות חיובית"),
	item: z.number().int().min(1, "כמות בחבילה חייבת להיות חיובית"),
	mainImage: z.string().url("תמונה ראשית חייבת להיות URL תקין").optional(),
	images: z
		.array(z.string().url("תמונה חייבת להיות URL תקין"))
		.max(2, "ניתן להוסיף עד 2 תמונות")
		.optional(),
	centralism: z.string().optional(),
	dosageType: z.enum(["flowering", "oil"]).optional(),
	brand: z.string().optional(),
});
export type TPharmacyProduct = z.infer<typeof PharmacyProductSchema>;

export const AccessoryProductSchema = ProductSchema.extend({
	category: ProductCategorySchema,
	images: z.array(z.string().url()).min(1, "חובה להוסיף לפחות תמונה אחת").optional(),
	mainImage: z.string().url("תמונה ראשית חייבת להיות URL תקין").optional(),
	weight: z.number().positive().optional(),
	dimensions: z
		.object({
			length: z.number().positive().optional(),
			width: z.number().positive().optional(),
			height: z.number().positive().optional(),
		})
		.optional(),
	tags: z.array(z.string()).default([]).optional(),
	requiresPrescription: z.boolean().default(false).optional(),
});
export type TAccessoryProduct = z.infer<typeof AccessoryProductSchema>;

export const CreateProductSchema = ProductSchema.omit({
	id: true,
	createdAt: true,
	updatedAt: true,
});

export const UpdateProductSchema = CreateProductSchema.partial().extend({
	id: z.string().min(1),
});

export type TProduct = z.infer<typeof ProductSchema>;
export type TProductCategory = z.infer<typeof ProductCategorySchema>;
export type TProductStatus = z.infer<typeof ProductStatusSchema>;
export type TCreateProduct = z.infer<typeof CreateProductSchema>;
export type TUpdateProduct = z.infer<typeof UpdateProductSchema>;

export const PRODUCT_CATEGORIES = ProductCategorySchema.Values;
export const PRODUCT_STATUSES = ProductStatusSchema.Values;
